import { useQuery } from "@tanstack/react-query";
import { getTaskQueryKey } from "@coworker/apprestructured/src/task-management/services/queryKeyHelper";
import { getTask } from "@coworker/apprestructured/src/task-management/services/tasks.service";
import { Task } from "@coworker/apprestructured/src/task-management/types/Task";
import { createPreviousOnNullPlaceholderDataFn } from "@coworker/apprestructured/src/task-management/services/queryHelper";

export function getTaskQueryConfig(id: string | null) {
  return {
    queryKey: getTaskQueryKey(id),
    queryFn: () => getTask(id!),
    enabled: id !== null,
    placeholderData: createPreviousOnNullPlaceholderDataFn<Task>(id),
  };
}

export function useTask(id: string | null) {
  return useQuery(getTaskQueryConfig(id));
}
